import InputMask from 'react-input-mask';
import  react, {useState, forwardRef} from "react";
import { Input } from 'reactstrap';

const Phone = forwardRef((props, ref) => {

    let [value,updateValue] = useState(props.value?props.value:'');
    let [error,updateError] = useState(props.error?props.error:'');
    let className = '';

    const handleChange = element => {
        element.target.value = element.target.value.replace(/[^0-9]/g,'');
        updateValue(element.target.value);
        props.onChange(element);
    };

    if(props.error){
        className="is-invalid";
    }
    
    return (
        <div ref={ref}>
            <Input
              type="text"
              mask={ value.length > 10 ? '(99) 99999-9999' : '(99) 9999-99999' }
              formatChars={{ 9: '[0-9]', '?': '[0-9 ]' }}
              maskChar={false}
              tag={InputMask}
              className={className}
              id={'id_'+props.name} 
              name={props.name} 
              onChange={handleChange}
              value={value}
              readOnly={props.readOnly}
              autoFocus={props.autoFocus?true:false}
            />
            {props.error && (
                <span id="terms-error" className="error invalid-feedback" style={{display:'inline'}}>{props.error}</span>
            )}
        </div>
    );
})
export default Phone;
